/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type UserAvatar_user$ref = any;
export type JobEventActorType = "AGENT" | "DISPATCH" | "SYSTEM" | "USER" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobEventRetried_event$ref: FragmentReference;
export type JobEventRetried_event = {|
  +timestamp: any,
  +actor: {|
    +type: JobEventActorType,
    +node: ?{|
      +name?: string,
      +uuid?: string,
      +$fragmentRefs: UserAvatar_user$ref,
    |},
  |},
  +automaticRule?: ?{|
    +exitStatus: ?string,
    +limit: ?string,
  |},
  +retriedInJob?: ?{|
    +uuid: string
  |},
  +$refType: JobEventRetried_event$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "uuid",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "JobEventRetried_event",
  "type": "JobEvent",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "timestamp",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "actor",
      "storageKey": null,
      "args": null,
      "concreteType": "JobEventActor",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "type",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "type": "User",
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                },
                v0,
                {
                  "kind": "FragmentSpread",
                  "name": "UserAvatar_user",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "InlineFragment",
      "type": "JobEventRetried",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "automaticRule",
          "storageKey": null,
          "args": null,
          "concreteType": "JobRetryRuleAutomatic",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "exitStatus",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "limit",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "retriedInJob",
          "storageKey": null,
          "args": null,
          "concreteType": "JobTypeCommand",
          "plural": false,
          "selections": [
            v0
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f61fba14a552df6475d12337d7be5ed9';
module.exports = node;
